"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTranslations = fetchTranslations;
var _axios = require("@ori/axios");
var _fetching = require("@ori/fetching");
var _md = _interopRequireDefault(require("crypto-js/md5"));
var _constants = require("../../internals/constants");
let axiosInstance;
function assertHeaders(headers) {
  return headers != null && typeof headers === 'object';
}
function getAxios() {
  if (!axiosInstance) {
    axiosInstance = (0, _axios.createAxiosWithCache)({
      key: ({
        headers,
        url,
        params
      }) => {
        const defaultKey = (0, _md.default)(`${url}_${JSON.stringify(params ?? {})}`).toString();
        if (assertHeaders(headers) && _fetching.ACCEPT_LANGUAGE in headers) {
          return `${headers[_fetching.ACCEPT_LANGUAGE]}_${defaultKey}`;
        }
        return defaultKey;
      },
      maxAge: _constants.TRANSLATIONS_CACHE_MAX_AGE
    });
  }
  return axiosInstance;
}
/**
 * @deprecated Use [fetchTranslationsWithNamespaces](../../utils/fetchTranslationsWithNamespaces.ts) which accepts TranslationsKeysWithNamespaces to support POEditor localizations only.
 * */
async function fetchTranslations({
  baseUrl,
  currentLanguage,
  keys,
  onError
}) {
  const url = new _axios.SafeURL(_constants.TRANSLATIONS_ENDPOINT, baseUrl);
  const entries = Object.values(keys);
  entries.forEach(value => url.searchParams.append(_constants.TRANSLATIONS_QUERY_PARAMETER_NAME, value));
  if (currentLanguage) {
    url.searchParams.append('sc_lang', currentLanguage);
  }
  try {
    const {
      data: translations
    } = await getAxios().get(url.toString(), currentLanguage ? {
      headers: {
        [_fetching.ACCEPT_LANGUAGE]: currentLanguage
      }
    } : undefined);
    return {
      // Now just swap keys from API with actual keys defined in keys
      translations
    };
  } catch (error) {
    if (_axios.axios.isAxiosError(error)) {
      onError?.(error);
      // Returns defaults when error occurs

      return {
        error,
        translations: keys
      };
    }
    throw error;
  }
}
//# sourceMappingURL=fetchTranslations.js.map